import React from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FaRoad,
  FaRupeeSign,
  FaClipboardList,
  FaBullhorn,
  FaPlusCircle,
  FaWater,
  FaToilet,
  FaHome,
  FaStore,
  FaBed,
  FaMoneyBillWave,
} from "react-icons/fa";
import { BsList } from "react-icons/bs";
import "../../../assets/css/Sidebar.css";
import { MdSpaceDashboard } from "react-icons/md";
import { FaExplosion, FaIndianRupeeSign } from "react-icons/fa6";
import { LuToilet } from "react-icons/lu";

function DepartmentSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const allowedFundManagers = ["Accountant", "F.O", "E.O", "MCIC", "chairman"];
  const userType = localStorage.getItem("type");
  let menuItems = [];

  menuItems.push({
    id: "dashboard",
    name: "Dashboard",
    icon: <MdSpaceDashboard />,
    path: "/departmentDashbord",
  });

  if (userType === "PWD" || userType === "AE" || userType === "Accountant" || userType === "F.O" || userType === "E.O" || userType === "MCIC") {
    menuItems.push({
      id: "pwd-report",
      name: "PWD Report List",
      icon: <FaRoad />,
      path: "/departmentDashboard/pwdreportlist",
    });
  } else if (userType === "Trade License") {
    menuItems.push(
      {
        id: "create-trade-license",
        name: "Create Trade License",
        icon: <FaPlusCircle />,
        path: "/departmentDashboard/create-trade-license",
      },
      {
        id: "trade-license-list",
        name: "Trade License List",
        icon: <FaClipboardList />,
        path: "/departmentDashboard/trade-license-list",
      },
      {
        id: "add-advertisement",
        name: "Add Advertisement",
        icon: <FaPlusCircle />,
        path: "/departmentDashboard/add-advertisement",
      },
      {
        id: "advertisement-list",
        name: "Advertisement List",
        icon: <FaBullhorn />,
        path: "/departmentDashboard/advertisement-list",
      },
      {
        id: "reports",
        name: "Reports",
        icon: <BsList />,
        path: "/departmentDashboard/reports",
      }
    );
  } else if (userType === "SAE") {
    menuItems.push({
      id: "pwd-report",
      name: "PWD Report List",
      icon: <FaRoad />,
      path: "/departmentDashboard/pwdreportlist",
    });
  } else if (userType === "Sanitary") {
    menuItems.push(
      {
        id: "sanitary-work-order",
        name: "Sanitary Work Order List",
        icon: <LuToilet />,
        path: "/departmentDashboard/sanitary-work-order",
      },
      {
        id: "sanitary-list",
        name: "Sanitary List",
        icon: <FaToilet />,
        path: "/departmentDashboard/sanitary",
      },
      {
        id: "water-tank",
        name: "Water tank",
        icon: <FaWater />,
        path: "/departmentDashboard/water-tank",
      }
    );
  }

  if (userType === "HFA") {
    menuItems.push({
      id: "hfa-beneficiary-list",
      name: "HFA Beneficiary List",
      icon: <FaHome />,
      path: "/departmentDashboard/hfa-beneficiary-list",
    });
  }

  if (userType === "Market") {
    menuItems.push(
      {
        id: "market-data",
        name: "Market Data",
        icon: <FaStore />,
        path: "/departmentDashboard/market-data",
      },
      {
        id: "room-rent",
        name: "Room Rent",
        icon: <FaBed />,
        path: "/departmentDashboard/room-rent",
      }
    );
  }

  if (userType === "tax-collector") {
    menuItems.push({
      id: "tax-collection",
      name: "Tax Collection",
      icon: <FaMoneyBillWave />,
      path: "/departmentDashboard/tax-collection",
    });
  }

  if (userType === "Accountant") {
    menuItems.push({
      id: "expessense",
      name: "Expessense",
      icon: <FaExplosion />,
      path: "/departmentDashboard/expessense",
    },
      {
        id: "chalan-list",
        name: "Chalan list",
        icon: <FaClipboardList />,
        path: "/departmentDashboard/chalan-list",
      });
  }

  if (userType === "Cash") {
    menuItems.push({
      id: "1",
      name: "Category",
      icon: <FaClipboardList />,
      path: "/departmentDashboard/cashcategory",
    },
      {
        id: "2",
        name: "SubCategory",
        icon: <FaClipboardList />,
        path: "/departmentDashboard/cashsubcatagory",
      },
      {
        id: "3",
        name: "Daily Chalan List",
        icon: <FaIndianRupeeSign />,
        path: "/departmentDashboard/cash-daily-chalan",
      }
    );
  }

  if (allowedFundManagers.includes(userType)) {
    menuItems.push({
      id: "fund-management",
      name: "Fund Managment",
      icon: <FaRupeeSign />,
      path: "/departmentDashboard/fundlist",
    });
  }

  const handleItemClick = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    if (path === "/departmentDashbord") {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="sidebar">
      <ul className="sidebar-menu">
        {menuItems.map((item, index) => (
          <motion.li
            key={item.id}
            className={`menu-item ${isActive(item.path) ? "active" : ""}`}
            onClick={() => handleItemClick(item.path)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
          >
            <span className="icon">{item.icon}</span>
            <span className="text">{item.name}</span>
          </motion.li>
        ))}
      </ul>
    </div>
  );
}

export default DepartmentSidebar;
